import React from "react";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import WhoWeServe from "@/components/site/WhoWeServe";
import HowItWorks from "@/components/site/HowItWorks";
import SizesShowcase from "@/components/site/SizesShowcase";
import FleetStrip from "@/components/site/FleetStrip";
import PricingTabs from "@/components/site/PricingTabs";
import GoogleReviewsSection from "@/components/site/GoogleReviewsSection";
import CommercialPricing from "@/components/site/CommercialPricing";
import ServiceArea from "@/components/site/ServiceArea";
import HomeStarsReviews from "@/components/site/HomeStarsReviews";
import Testimonials from "@/components/site/Testimonials";
import Faq from "@/components/site/Faq";
import FinalCta from "@/components/site/FinalCta";
import Footer from "@/components/site/Footer";
import MobileStickyBar from "@/components/site/MobileStickyBar";

export default function Home() {
  return (
    <div className="min-h-screen bg-white text-slate-900">
      <Header />
      <main>
        <Hero />
        <WhoWeServe />
        <HowItWorks />
        <SizesShowcase />
        <FleetStrip />
        {/* Pricing = trust-building section. Book Now button goes to /book. */}
        <PricingTabs />
        {/* Live Google reviews trust block — placed at the moment of decision. */}
        <GoogleReviewsSection />
        <HomeStarsReviews />
        <CommercialPricing />
        <ServiceArea />
        <Testimonials />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
      <MobileStickyBar />
      <Toaster position="top-center" richColors />
    </div>
  );
}
